import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HeadsetMicIcon(props: IconProps) {
    return <Icon {...props} iconKey={"headset_mic"}/>
}
